import { ArrowUpLeft, ArrowUpRight } from "lucide-react";
import { scrollToId } from "../hooks/useSmoothScroll";
import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const SolutionFinder = ({ onSelect }) => {
  const { t, dir } = useLang();
  const Arrow = dir === "rtl" ? ArrowUpLeft : ArrowUpRight;

  const labelFor = (value) =>
    t.FINANCE_TYPE_OPTIONS.find((o) => o.value === value)?.label || value;

  const pick = (solution) => {
    onSelect(solution);
    scrollToId("consultation");
  };

  return (
    <section id="finder" className="bg-ivory text-[#202020] py-24 md:py-32" data-testid="solution-finder-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="label-caps">{t.UI.finderLabel}</p>
          <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
            {t.UI.finderTitle}
          </h2>
          <p className="mt-5 text-smoke leading-relaxed">{t.UI.finderBody}</p>
        </Reveal>
        <div className="mt-14 border-t hairline-light">
          {t.FINDER.map((f, i) => (
            <Reveal key={f.scenario} delay={i * 0.05} y={20}>
              <button
                onClick={() => pick(f.solution)}
                className="group w-full flex items-center justify-between gap-6 border-b hairline-light py-7 sm:py-9 text-start transition-[background-color,padding] duration-500 hover:bg-white hover:px-6"
                data-testid={`finder-row-${i + 1}`}
              >
                <span className="font-serif-lux font-light text-xl sm:text-3xl leading-snug">
                  “{f.scenario}”
                </span>
                <span className="flex items-center gap-4 shrink-0">
                  <span className="hidden sm:block text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-champagne">
                    {labelFor(f.solution)}
                  </span>
                  <Arrow
                    size={22}
                    className="text-champagne transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
                  />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionFinder;
